<template>
  <div class="footIner">
    <div class="foot">
      <ul>
        <li style="user-select: none"> <i class="el-icon-phone-outline"></i> 电话：010-82062112 &nbsp; &nbsp;  <i class="el-icon-message"></i> 邮箱：info@imspp.org.cn</li>

        <!-- <li style="user-select: none">技术支持电话：010-82062112（咨询时间：工作日9:00-17:00） 咨询邮箱：im@imspp.org.cn</li> -->
        <li style="user-select: none;margin:10px 0;"> <a href="https://beian.miit.gov.cn/" rel="noreferrer"
            target="_blank" style="color: #fff;">京ICP备2021031678号-1</a>
          &nbsp;
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502053726" rel="noreferrer" target="_blank"
            style="color: #fff;"><img src="../assets/icon.png" alt="" style="width: 14px;height: 15px;margin-right: 5px;">京公网安备11010502053726号</a>
        </li>
        <li style="user-select: none">版权所有@北京国之合创新与知识产权研究院</li>
      </ul>
      <div >
        <p style="text-align: center;">关注我们</p>
        <img src="../assets/wechar.jpg" alt="" class="footerPic">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    msg: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["screenHeight"]),
  },
  created() { },
  methods: {
    sy() {
      this.$router.push({ name: "index" });
    },
    xwzx() {
      this.$router.push({ name: "Rotation" });
    },

    EnterpriseCenter() {
      var value = sessionStorage.getItem("user");

      if (value != "" && value != undefined) {
        this.$router.push({ name: "EnterpriseCenter" });
      } else {
        this.$router.push({ name: "Signin" });
      }
    },
  },
};
</script>


<style lang="less" scoped>
.hello {
  height: 100px;
  width: 100%;
}

.footIner {
  background: #5780F2;
  width: 100%;

  .foot {
    width: 70%;
    height: 150px;
    display: flex;
    align-items: center;
    // flex-direction: column;
    justify-content: space-around;
    margin: 0 auto;
  }


  .footerPic {
    width: 90px;
    height: 90px;
    margin-top: 3px;
  }

  ul {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #fff;
  }

  a {
    text-decoration: none;
    cursor: pointer;
  }

  p {
    font-size: 14px;
    color: #fff;
  }
}
</style>